import React from 'react';
import Modal from 'react-bootstrap/Modal'
import {useDispatch, useSelector} from "react-redux";
import {deleteUnit, setDeleteUnitId} from "../../actions/unit";

const UnitDeleteForm = () => {

    const dispatch = useDispatch();

    const {delete_unit, currentPage, numberOfPages, units} = useSelector(state => state.unit);

    const closeModal = () =>{
        // removing unit from redux state by sending null setDeleteUnitId
        dispatch(setDeleteUnitId(null))
    };

    let getPage = null;

    const onConfirm = () =>{

        if ((currentPage === numberOfPages) && (units.length === 1) ){
            getPage = (currentPage - 1);
        }
        else{
            getPage = currentPage;
        }
        dispatch(deleteUnit(delete_unit.id, getPage))
    };

    let condition = false;
    if(delete_unit !== null)
        condition = true;

    return (
        <div>
            <Modal show={condition} onHide={closeModal}>
                <Modal.Header className="bg-danger" closeButton>
                    <Modal.Title className="text-white" >O'lchov birligini o'chirish</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Siz haqiqatdan ham ushbu o'lchov birligini o'chirmoqchimisiz ?
                </Modal.Body>
                <Modal.Footer>
                    <button onClick={closeModal} className="btn btn-secondary">YO'Q</button>
                    <button onClick={onConfirm} className="btn btn-primary">HA</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default UnitDeleteForm;